import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 25 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"ai-music"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M5 15.9229C6.65677 15.9229 7.99987 17.2661 8 18.9229C8 20.5797 6.65685 21.9229 5 21.9229C3.34315 21.9229 2 20.5797 2 18.9229C2.00013 17.2661 3.34323 15.9229 5 15.9229Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M18 13.9229C19.6568 13.9229 20.9999 15.2661 21 16.9229C21 18.5797 19.6569 19.9229 18 19.9229C16.3431 19.9229 15 18.5797 15 16.9229C15.0001 15.2661 16.3432 13.9229 18 13.9229Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8 17.9231V3.92308L14 3M21 10.9231V15.9231M21 16.9231C21 18.5799 19.6569 19.9231 18 19.9231C16.3431 19.9231 15 18.5799 15 16.9231C15 15.2662 16.3431 13.9231 18 13.9231C19.6569 13.9231 21 15.2662 21 16.9231ZM8 18.9231C8 20.5799 6.65685 21.9231 5 21.9231C3.34315 21.9231 2 20.5799 2 18.9231C2 17.2662 3.34315 15.9231 5 15.9231C6.65685 15.9231 8 17.2662 8 18.9231Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M19.75 3L20.2697 4.23028L21.5 4.75L20.2697 5.26972L19.75 6.5L19.2303 5.26972L18 4.75L19.2303 4.23028L19.75 3Z","strokeWidth":"props.strokeWidth"}}]}]};

const AiMusic = Vue.extend<IconProps>({
  name: 'AiMusicIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'ai-music',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default AiMusic;
